import script from "./singleCall.vue?vue&type=script&setup=true&lang=js"
export * from "./singleCall.vue?vue&type=script&setup=true&lang=js"

import "./singleCall.vue?vue&type=style&index=0&id=122a7eec&lang=scss&scoped=true"

import exportComponent from "E:\\immm\\webim-vue-demo-vue3-miniCore\\webim-vue-demo-vue3-miniCore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122a7eec"]])

export default __exports__